exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".switch_pin_type[data-v-038aee49]{margin-top:13px;margin-bottom:30px}.switch_pin_type-button[data-v-038aee49]{display:flex;align-items:center;box-sizing:border-box;border:1px solid #9d9d9d;border-radius:33px;margin-bottom:10px;padding-left:17px;height:66px;width:140px;background:#fff;line-height:1;font-size:26px;font-weight:700;color:#9d9d9d}.switch_pin_type-button.is-current[data-v-038aee49]{border-color:#0174bf;border-width:2px;color:#0174bf}.switch_pin_type-label[data-v-038aee49]{margin-left:9px}.switch_pin_type-label--person[data-v-038aee49]{margin-left:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-038aee49","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/map/controller/switch_pin_type.vue
// module id = 795
// module chunks = 0